module.exports = __webpack_public_path__ + "img/zao.83dd16c3.png";